var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysWarning2 = function SvgSysWarning2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 11.783a.77.77 0 0 1 .091-.363l4.86-8.586.001-.001a.681.681 0 0 1 .24-.247.6.6 0 0 1 .616 0c.095.057.179.14.24.247 0 0 0 0 0 0l4.86 8.587a.77.77 0 0 1 .001.73.685.685 0 0 1-.24.258.601.601 0 0 1-.308.092H3.139a.6.6 0 0 1-.309-.092.686.686 0 0 1-.24-.258.77.77 0 0 1-.09-.367ZM8 6v2.5M8 10.5h.01"
  })));
};
export default SvgSysWarning2;